module.exports = "././img/client_logo.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/client_logo.png
// module id = 266
// module chunks = 0